"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowModel = exports.WfConnector = exports.WfSegment = exports.ViewNode = exports.GuiNode = exports.ActivityNode = exports.DynamicWaitNode = exports.DynamicForkNode = exports.WaitNode = exports.ForkNode = exports.EndNode = exports.StartNode = exports.Variable = exports.Visit = exports.Link = exports.Param = exports.WfTextBoxNode = exports.WfTextLabelNode = exports.WfTextNode = exports.ScopeNode = exports.WfNode = exports.HorizontalAlignment = exports.VerticalAlignment = exports.ColorMode = exports.ExecutionContext = void 0;
const Utilities_1 = require("../../javascript/Utilities");
class WfElem {
    constructor() {
        this.Etag = "";
    }
    SetNewEtag() {
        this.Etag = Utilities_1.synUtil.getGUID(true);
    }
}
class ExecutionContext {
    constructor() {
        this.$type = "At.Technodat.Workflow.ExecutionContext, TdWorkflow";
    }
}
exports.ExecutionContext = ExecutionContext;
var ColorMode;
(function (ColorMode) {
    ColorMode[ColorMode["None"] = 0] = "None";
    ColorMode[ColorMode["Visisted"] = 1] = "Visisted";
    ColorMode[ColorMode["Future"] = 2] = "Future";
    ColorMode[ColorMode["Active"] = 3] = "Active";
})(ColorMode = exports.ColorMode || (exports.ColorMode = {}));
var VerticalAlignment;
(function (VerticalAlignment) {
    VerticalAlignment["Top"] = "Top";
    VerticalAlignment["Center"] = "Center";
    VerticalAlignment["Bottom"] = "Bottom";
})(VerticalAlignment = exports.VerticalAlignment || (exports.VerticalAlignment = {}));
var HorizontalAlignment;
(function (HorizontalAlignment) {
    HorizontalAlignment["Left"] = "Left";
    HorizontalAlignment["Center"] = "Center";
    HorizontalAlignment["Right"] = "Right";
})(HorizontalAlignment = exports.HorizontalAlignment || (exports.HorizontalAlignment = {}));
class WfNode extends WfElem {
    constructor() {
        super();
        this.Id = "";
        this.Description = "";
        this.PosX = 0;
        this.PosY = 0;
        this.Width = 0;
        this.Height = 0;
        this.ExitList = [];
        this.CompletedList = [];
        this.ExecutionContextList = [];
        this.ColorMode = ColorMode.None;
        /**
         *    Range: 0 - 1, 0 = Default => transparent
         * */
        this.Opacity = 1;
        this.$type = "At.Technodat.Workflow.Node, TdWorkflow";
        this.ColorBlue = 255;
        this.ColorGreen = 255;
        this.ColorRed = 255;
    }
    static fromJSON(node) {
        let wfNode = Object.assign(new WfNode(), node);
        wfNode.ExitList = [];
        //for(let link of node["ExitList"])
        //    wfNode.ExitList.push(Object.assign(new Link(),link));            
        wfNode.CompletedList = [];
        for (let visit of node["CompletedList"])
            wfNode.CompletedList.push(Object.assign(new Visit(), visit));
        return wfNode;
    }
    /**
     *  return a deep copy
     */
    clone() {
        return WfNode.fromJSON(this);
    }
}
exports.WfNode = WfNode;
class ScopeNode extends WfNode {
    constructor() {
        super(...arguments);
        this.$type = "At.Technodat.Workflow.ScopeNode, TdWorkflow";
        this.VariableList = [];
    }
    static fromJSON(node) {
        let scopeNode = Object.assign(new ScopeNode(), super.fromJSON(node));
        scopeNode.VariableList = [];
        for (let variable of node["VariableList"])
            scopeNode.VariableList.push(Object.assign(new Variable(), variable));
        return scopeNode;
    }
    /**
     *  return a deep copy
     */
    clone() {
        return ScopeNode.fromJSON(this);
    }
}
exports.ScopeNode = ScopeNode;
class WfTextNode extends WfNode {
    constructor() {
        super();
        this.TextColorRed = 0;
        this.TextColorGreen = 0;
        this.TextColorBlue = 0;
        this.$type = "At.Technodat.Workflow.VisualElement, TdWorkflow";
        /**
        *    Range: 0 - 1, 0 = Default => transparent
        * */
        this.TextOpacity = 1;
        this.FontSize = 12;
    }
    /**
     *  return a deep copy
     */
    clone() {
        return WfTextNode.fromJSON(this);
    }
    static fromJSON(textNode) {
        let wfTextNode = Object.assign(new WfTextNode(), super.fromJSON(textNode));
        wfTextNode.TextColorRed = textNode["TextColorRed"];
        wfTextNode.TextColorGreen = textNode["TextColorGreen"];
        wfTextNode.TextColorBlue = textNode["TextColorBlue"];
        wfTextNode.Opacity = textNode["Opacity"];
        wfTextNode.TextOpacity = textNode["TextOpacity"];
        wfTextNode.FontSize = textNode["FontSize"];
        return wfTextNode;
    }
}
exports.WfTextNode = WfTextNode;
class WfTextLabelNode extends WfTextNode {
    constructor() {
        super();
        this.$type = "At.Technodat.Workflow.TextLabelNode, TdWorkflow";
        this.Opacity = 0;
    }
    clone() {
        return WfTextLabelNode.fromJSON(this);
    }
    static fromJSON(textLabelNode) {
        let node = Object.assign(new WfTextLabelNode(), super.fromJSON(textLabelNode));
        return node;
    }
}
exports.WfTextLabelNode = WfTextLabelNode;
class WfTextBoxNode extends WfTextNode {
    constructor() {
        super(...arguments);
        this.$type = "At.Technodat.Workflow.TextBoxNode, TdWorkflow";
        this.BorderColorRed = 0;
        this.BorderColorGreen = 0;
        this.BorderColorBlue = 0;
        /**
         *    Range: 0 - 1, 1 = Default => transparent
         * */
        this.BorderOpacity = 1;
        this.VerticalAlign = VerticalAlignment.Center;
        this.HorizontalAlig = HorizontalAlignment.Center;
    }
    clone() {
        return WfTextBoxNode.fromJSON(this);
    }
    static fromJSON(node) {
        return Object.assign(new WfTextBoxNode(), super.fromJSON(node));
    }
}
exports.WfTextBoxNode = WfTextBoxNode;
class Param {
    constructor() {
        this.$type = "At.Technodat.Workflow.Param, TdWorkflow";
    }
}
exports.Param = Param;
class Link {
    constructor() {
        this.$type = "At.Technodat.Workflow.Link, TdWorkflow";
        this.Id = "";
    }
}
exports.Link = Link;
class Visit {
    constructor() {
        this.$type = "At.Technodat.Workflow.Visit, TdWorkflow";
    }
}
exports.Visit = Visit;
class Variable {
    constructor() {
        this.$type = "At.Technodat.Workflow.Variable, TdWorkflow";
        this.IsArray = false;
        this.Intern = false;
        this.Modified = false;
        this.Used = false;
    }
}
exports.Variable = Variable;
class StartNode extends WfNode {
    constructor() {
        super(...arguments);
        this.$type = "At.Technodat.Workflow.StartNode, TdWorkflow";
    }
    static fromJSON(node) {
        return Object.assign(new StartNode(), super.fromJSON(node));
    }
    /**
     *  return a deep copy
     */
    clone() {
        return StartNode.fromJSON(this);
    }
}
exports.StartNode = StartNode;
class EndNode extends WfNode {
    constructor() {
        super(...arguments);
        this.$type = "At.Technodat.Workflow.EndNode, TdWorkflow";
    }
    static fromJSON(node) {
        return Object.assign(new EndNode(), super.fromJSON(node));
    }
    /**
     *  return a deep copy
     */
    clone() {
        return EndNode.fromJSON(this);
    }
}
exports.EndNode = EndNode;
class ForkNode extends WfNode {
    constructor() {
        super(...arguments);
        this.$type = "At.Technodat.Workflow.ForkNode, TdWorkflow";
    }
    static fromJSON(node) {
        return Object.assign(new ForkNode(), super.fromJSON(node));
    }
    /**
     *  return a deep copy
     */
    clone() {
        return ForkNode.fromJSON(this);
    }
}
exports.ForkNode = ForkNode;
class WaitNode extends WfNode {
    constructor() {
        super(...arguments);
        this.$type = "At.Technodat.Workflow.WaitNode, TdWorkflow";
    }
    static fromJSON(node) {
        return Object.assign(new WaitNode(), super.fromJSON(node));
    }
    /**
     *  return a deep copy
     */
    clone() {
        return WaitNode.fromJSON(this);
    }
}
exports.WaitNode = WaitNode;
class DynamicForkNode extends ScopeNode {
    constructor() {
        super(...arguments);
        this.$type = "At.Technodat.Workflow.DynamicForkNode, TdWorkflow";
    }
    static fromJSON(node) {
        return Object.assign(new DynamicForkNode(), super.fromJSON(node));
    }
    /**
     *  return a deep copy
     */
    clone() {
        return DynamicForkNode.fromJSON(this);
    }
}
exports.DynamicForkNode = DynamicForkNode;
class DynamicWaitNode extends WfNode {
    constructor() {
        super(...arguments);
        this.$type = "At.Technodat.Workflow.DynamicWaitNode, TdWorkflow";
        this.CompletedThreadList = [];
    }
    static fromJSON(node) {
        return Object.assign(new DynamicWaitNode(), super.fromJSON(node));
    }
    /**
     *  return a deep copy
     */
    clone() {
        return DynamicWaitNode.fromJSON(this);
    }
}
exports.DynamicWaitNode = DynamicWaitNode;
class ActivityNode extends ScopeNode {
    constructor() {
        super(...arguments);
        this.$type = "At.Technodat.Workflow.ActivityNode, TdWorkflow";
        this.ParamList = [];
        this.FunctionId = "";
    }
    /**
     *  return a deep copy
     */
    clone() {
        return ActivityNode.fromJSON(this);
    }
    static fromJSON(node) {
        let activityNode = Object.assign(new ActivityNode(), super.fromJSON(node));
        activityNode.FunctionId = node["FunctionId"];
        activityNode.ParamList = [];
        for (let param of node["ParamList"])
            activityNode.ParamList.push(Object.assign(new Param(), param));
        return activityNode;
    }
}
exports.ActivityNode = ActivityNode;
class GuiNode extends WfNode {
    constructor() {
        super(...arguments);
        this.$type = "At.Technodat.Workflow.GuiNode, TdWorkflow";
        this.ParamList = [];
        this.GuiId = "";
    }
    static fromJSON(node) {
        let guiNode = Object.assign(new GuiNode(), super.fromJSON(node));
        guiNode.ParamList = [];
        for (let param of node["ParamList"])
            guiNode.ParamList.push(Object.assign(new Param(), param));
        return guiNode;
    }
    /**
     *  return a deep copy
     */
    clone() {
        return GuiNode.fromJSON(this);
    }
}
exports.GuiNode = GuiNode;
class ViewNode extends WfNode {
    constructor() {
        super(...arguments);
        this.$type = "At.Technodat.Workflow.ViewNode, TdWorkflow";
        this.ReferencedShapes = [];
    }
    static fromJSON(node) {
        let viewNode = Object.assign(new ViewNode(), super.fromJSON(node));
        viewNode.ReferencedShapes = [];
        for (let referencedShape of node["ReferencedShapes"])
            viewNode.ReferencedShapes.push(referencedShape);
        return viewNode;
    }
    /**
     *  return a deep copy
     */
    clone() {
        return ViewNode.fromJSON(this);
    }
}
exports.ViewNode = ViewNode;
class WfSegment {
    constructor() {
        this.$type = "At.Technodat.Workflow.Segment, TdWorkflow";
        this.Direction = "";
        this.Length = 0;
    }
}
exports.WfSegment = WfSegment;
class WfConnector extends WfElem {
    constructor() {
        super(...arguments);
        this.$type = "At.Technodat.Workflow.Connector, TdWorkflow";
        this.Id = "";
        this.IsViewNode = false;
        this.SegmentList = [];
    }
    /**
     *  return a deep copy
     */
    clone() {
        return Object.assign(new WfConnector(), this);
    }
}
exports.WfConnector = WfConnector;
class WorkflowModel {
    constructor() {
        this.$type = "At.Technodat.Workflow.WorkflowModel, TdWorkflow";
        this.VariableList = [];
        this.NodeList = [];
        this.ConnectorList = [];
        //#endregion Helpers    
    }
    //#region Member Methods
    static fromJSON(wfModel) {
        let workflowModel = new WorkflowModel();
        workflowModel.DocId = wfModel["DocId"];
        workflowModel.Hash = wfModel["Hash"];
        workflowModel.FileVersion = wfModel["FileVersion"];
        //this.$type = wfModel["$type"];
        for (let variable of wfModel["VariableList"])
            workflowModel.VariableList.push(Object.assign(new Variable(), variable));
        for (let node of wfModel["NodeList"]) {
            let wfNode = undefined;
            switch (node["$type"]) {
                case "At.Technodat.Workflow.StartNode, TdWorkflow":
                    wfNode = StartNode.fromJSON(node);
                    break;
                case "At.Technodat.Workflow.EndNode, TdWorkflow":
                    wfNode = EndNode.fromJSON(node);
                    break;
                case "At.Technodat.Workflow.ActivityNode, TdWorkflow":
                    wfNode = ActivityNode.fromJSON(node);
                    break;
                case "At.Technodat.Workflow.ForkNode, TdWorkflow":
                    wfNode = ForkNode.fromJSON(node);
                    break;
                case "At.Technodat.Workflow.WaitNode, TdWorkflow":
                    wfNode = WaitNode.fromJSON(node);
                    break;
                case "At.Technodat.Workflow.DynamicForkNode, TdWorkflow":
                    wfNode = DynamicForkNode.fromJSON(node);
                    break;
                case "At.Technodat.Workflow.DynamicWaitNode, TdWorkflow":
                    wfNode = DynamicWaitNode.fromJSON(node);
                    break;
                case "At.Technodat.Workflow.ViewNode, TdWorkflow":
                    wfNode = ViewNode.fromJSON(node);
                    break;
                case "At.Technodat.Workflow.GuiNode, TdWorkflow":
                    wfNode = GuiNode.fromJSON(node);
                    ;
                    break;
                case "At.Technodat.Workflow.TextLabelNode, TdWorkflow":
                    wfNode = WfTextLabelNode.fromJSON(node);
                    break;
                case "At.Technodat.Workflow.TextBoxNode, TdWorkflow":
                    wfNode = WfTextBoxNode.fromJSON(node);
                    break;
            }
            if (wfNode) {
                workflowModel.NodeList.push(wfNode);
                for (let link of wfNode.ExitList) {
                    let newConnector = new WfConnector();
                    newConnector.Id = WorkflowModel.getNewElementId();
                    newConnector.SourceNodeId = wfNode.Id;
                    newConnector.TargetNodeId = link.Id;
                    newConnector.Path = link.Path;
                    newConnector.Description = link.Description;
                    workflowModel.ConnectorList.push(newConnector);
                }
            }
        }
        //workflowModel.addConnectionsBetweenViewNodes();
        if (wfModel["ConnectorList"]) {
            let viewNodes = workflowModel.NodeList.filter(node => node instanceof ViewNode);
            for (let connector of wfModel["ConnectorList"]) {
                let wfConnector = Object.assign(new WfConnector(), connector);
                wfConnector.IsViewNode = wfConnector.SourceNodeId != undefined && viewNodes.findIndex(node => node.Id === wfConnector.SourceNodeId) !== -1;
                workflowModel.ConnectorList.push(wfConnector);
            }
        }
        workflowModel.clearAllExitLists();
        return workflowModel;
    }
    static toJSON(wfModel) {
        return JSON.stringify(wfModel);
    }
    /**
     *  return a deep copy
     */
    clone() {
        return WorkflowModel.fromJSON(this);
    }
    static getNewElementId() {
        return "{" + Utilities_1.synUtil.getGUID(false) + "}";
    }
    /**
     * resolves ExitList
     */
    resolveExitList() {
        let that = this;
        for (let node of this.NodeList) {
            that.clearExitList(node);
            let connectors = that.ConnectorList.filter(connector => connector.SourceNodeId === node.Id && connector.TargetNodeId);
            for (let connector of connectors) {
                let newLink = new Link();
                newLink.Id = connector.TargetNodeId;
                newLink.Description = connector.Description;
                newLink.Path = connector.Path;
                node.ExitList.push(newLink);
            }
        }
    }
    //#endregion Member Methods
    //#region  Helpers
    clearAllExitLists() {
        let that = this;
        for (let node of this.NodeList)
            that.clearExitList(node);
    }
    clearExitList(node) {
        if (node)
            node.ExitList.splice(0);
    }
    addConnectionsBetweenViewNodes() {
        let that = this;
        let relevantNodes = that.NodeList.filter(node => node instanceof ViewNode);
        let addConnectors = [];
        for (let node of relevantNodes) {
            let viewNode = node;
            let outConnectors = that.getReferencedOutConnections(viewNode);
            let relevantNodes = that.NodeList.filter(node => node instanceof ViewNode);
            for (let tmpNode of relevantNodes) {
                if (tmpNode != viewNode) {
                    let tmpViewNode = tmpNode;
                    for (let outConnector of outConnectors) {
                        if (tmpViewNode.ReferencedShapes.indexOf(outConnector.TargetNodeId) != -1) {
                            if (that.ConnectorList.findIndex(c => c.IsViewNode && c.SourceNodeId === viewNode.Id && c.TargetNodeId === tmpViewNode.Id) === -1) {
                                let newWfConnector = new WfConnector();
                                newWfConnector.Id = WorkflowModel.getNewElementId();
                                newWfConnector.IsViewNode = true;
                                newWfConnector.SourceNodeId = viewNode.Id;
                                newWfConnector.TargetNodeId = tmpViewNode.Id;
                                that.ConnectorList.push(newWfConnector);
                                addConnectors.push(newWfConnector);
                            }
                        }
                    }
                }
            }
        }
        return addConnectors;
    }
    getReferencedOutConnections(viewNode) {
        let that = this;
        let connectors = [];
        for (let referencedShape of viewNode.ReferencedShapes) {
            let foundConnectors = that.ConnectorList.filter(c => c.SourceNodeId === referencedShape);
            for (let foundConnector of foundConnectors) {
                if (connectors.indexOf(foundConnector) === -1)
                    connectors.push(foundConnector);
            }
        }
        return connectors;
    }
}
exports.WorkflowModel = WorkflowModel;
